export function getGretaAIChatTurnStartedAt(isThinking, storedTurnStartedAt) {
  return isThinking ? (storedTurnStartedAt ?? Date.now()) : null
}
